// Vendor imports
const React = require('react')
const _ = require('lodash')
// Client V2 common imports
const useToggleState = require('client-v2/common/hooks/toggle-state')
// Entry imports
const UserListModal = require('client-v2/into-landing/components/user-list-modal')
const IntoHeader = require('client-v2/into-landing/containers/header/component-smart')
const SMSModal = require('client-v2/into-landing/containers/sms-modal/component-smart')
const EmbeddedPlayer = require('client-v2/common/components/embedded-player')
const Immutable = require('immutable');

// eslint-disable-next-line complexity
function IntoContentProfileLayout(props) {
  const {
    // Flags
    isDesktop,
    isShareReferral,
    // Values
    embedUrl,
    likers,
    provider: { faviconURL, id },
    referredBy,
    related,
    title,
    thumbnail,
    url,
    // Callbacks
    showSMSModal
  } = props
  const [isBlurred, toggleBlurred] = useToggleState(false)
  const [ isUserModalVisible, toggleUserModalVisible ] = useToggleState(false)

  const handleSMSModal = React.useCallback(
    () => {
      if (isDesktop) {
        const root = document.getElementById('root')
        if (isBlurred) {
          root.classList.remove('no-scroll')
        } else {
          root.classList.add('no-scroll')
        }
        toggleBlurred()
        showSMSModal({
          deeplinkData: null,
          isDownloadPromptVisible: false
        })
      }
    },
    [isBlurred, isDesktop, toggleBlurred, showSMSModal]
  )

  const handleViewClick = React.useCallback(
    () => {
      const root = document.getElementById('root')
      if (isUserModalVisible) {
        root.classList.remove('no-scroll')
      } else {
        root.classList.add('no-scroll')
      }
      toggleUserModalVisible()
    },
    [ isUserModalVisible, toggleUserModalVisible ]
  )
  return (
    <React.Fragment>
      <SMSModal isBlurred={isBlurred} onDismiss={handleSMSModal} dismissOnOuterClick={true} />
      <div
        className={`min-h-available md:min-h-screen md:h-screen flex flex-col ${
          isBlurred ? 'blur-lg' : ''
        }`}
      >
        <IntoHeader onDownloadClick={handleSMSModal} />
        <div className="md:flex-1 flex flex-col-reverse lg:flex-row lg:space-x-10 px-4 lg:px-6">
          <div className="lg:w-80 py-6">
            <div className="space-y-10">
            {referredBy && 
              <div>
                <div className="flex mb-4">
                  <p className="flex-1 font-medium opacity-50">{isShareReferral ? 'Shared by' : 'Liked by'}</p>
                </div>
                <div className="mb-6 space-y-4">
                  <a
                    key={referredBy.username}
                    href={referredBy.username}
                    className="flex items-center space-x-4"
                  >
                    <img
                      className="shrink-0 inline-block aspect-square object-cover rounded-full w-14"
                      src={referredBy['photo_url']}
                      alt={referredBy['display_name']}
                    />
                    <div className="flex-1 flex flex-col min-w-0">
                      <p className="font-medium truncate">{referredBy['display_name']}</p>
                      <p className="text-sm truncate opacity-50 mb-1">{`@${referredBy.username}`}</p>
                    </div>
                  </a>
                </div>
              </div>
            }
              <div className="space-y-6">
                <a
                  href={url}
                  className="leading-tight text-lg font-medium"
                  rel="external nofollow noopener noreferrer"
                  target={'_blank'}
                >
                  {title}
                </a>
                <a
                  className="leading-tight flex space-x-4 items-center opacity-75"
                  href={url}
                  rel={'external nofollow noopener noreferrer'}
                  target={'_blank'}
                >
                  <span className="bg-white bg-opacity-20 rounded-full p-2">
                    <img
                      className="aspect-square w-4"
                      src={faviconURL}
                      style={{ filter: 'invert(1)' }}
                    />
                  </span>
                  <span className="provider text-sm font-medium">{_.capitalize(id)}</span>
                </a>
              </div>
              {likers && likers.size > 0 && (
                <div>
                  <div className="flex mb-4">
                    <p className="flex-1 font-medium opacity-50">{`${likers.size} ${
                      likers.size > 1 ? 'Likes' : 'Like'
                    }`}</p>
                    {likers && likers.size > 4 && (
                      <button
                        className="btn btn-link text-sm font-normal text-orange-500"
                        onClick={handleViewClick}
                      >
                        View all
                      </button>
                    )}
                  </div>
                  <div className="mb-6 space-y-4">
                    {likers.slice(0, 4).map(liker => (
                      <a
                        key={liker.username}
                        href={liker.username}
                        className="flex items-center space-x-4"
                      >
                        <img
                          className="shrink-0 inline-block aspect-square object-cover rounded-full w-14"
                          src={liker['photo_url']}
                          alt={liker['display_name']}
                        />
                        <div className="flex-1 flex flex-col min-w-0">
                          <p className="font-medium truncate">{liker['display_name']}</p>
                          <p className="text-sm truncate opacity-50 mb-1">{`@${liker.username}`}</p>
                        </div>
                        <button className="btn btn-square">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="aspect-square w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 4v16m8-8H4"
                            ></path>
                          </svg>
                        </button>
                      </a>
                    ))}
                  </div>
                </div>
              )}
              {related.size > 0 && (
                <div>
                  <p className="font-medium opacity-50 mb-3">Related</p>
                  <div className="flex flex-wrap overflow-hidden mb-4 h-6">
                    {related.map(item => (
                      <a
                        key={item.slug}
                        href={`/topic/${item.slug}`}
                        className="btn btn-link relative z-10"
                      >
                        <span className="tag mr-2 mb-2">{item.name}</span>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {embedUrl && (
            <div className="flex-1 flex relative lg:mb-10">
              <img
                src={thumbnail}
                className="lg:absolute top-0 left-0 w-full h-full object-contain -z-1"
                alt="content"
              />
              <EmbeddedPlayer
                className="embed -z-1"
                src={embedUrl}
                fallbackUrl={url}
                isDisclosedForced={true}
              />
            </div>
          )}
          {!embedUrl && (
            <div className="flex-1 flex relative lg:mb-10 justify-center">
              <img
                className="lg:absolute top-0 w-fit h-full object-contain -z-1"
                src={thumbnail}
                alt={title}
              />
            </div>
          )}
        </div>
      </div>
      {likers && likers.size > 0 && (
        <UserListModal
          handleSMSModal={handleSMSModal}
          isModalVisible={isUserModalVisible}
          onDismiss={toggleUserModalVisible}
          caption={`${likers.size} ${likers.size > 1 ? 'Likes' : 'Like'}`}
          users={likers}
        />
      )}
      <div id="modal-container"></div>
      <div
        id="svelte-announcer"
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '0',
          top: '0',
          clip: 'rect(0, 0, 0, 0)',
          clipPath: 'inset(50%)',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: '1px',
          height: '1px'
        }}
      ></div>
    </React.Fragment>
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const UserRecord = require('client-v2/common/state/user/record')
  IntoContentProfileLayout.propTypes = {
    isDesktop: PropTypes.bool,
    embedUrl: PropTypes.string,
    likers: PropTypes.instanceOf(Immutable.Iterable).isRequired,
    provider: PropTypes.object,
    referredBy: PropTypes.shape(UserRecord.propTypes),
    related: PropTypes.instanceOf(Immutable.Iterable),
    title: PropTypes.string,
    thumbnail: PropTypes.string,
    url: PropTypes.string,
    showSMSModal: PropTypes.func
  }
}

module.exports = IntoContentProfileLayout
